import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface ExperienceStore {
  width: number
  height: number
  pixelRatio: number
  init: boolean
  setWidth: (width: number) => void
  setHeight: (height: number) => void
  setPixelRatio: (pixelRatio: number) => void
  setInit: () => void
}

export const useExperienceStore = create<ExperienceStore>()(
  devtools((set) => ({
    init: false,
    width: 0,
    height: 0,
    pixelRatio: 0,
    setInit: () => set({ init: true }),
    setWidth: (width: number) => set({ width }),
    setHeight: (height: number) => set({ height }),
    setPixelRatio: (pixelRatio: number) => set({ pixelRatio }),
  })),
)

interface SectionStore {
  currentSection: string | null
  setCurrentSection: (section: string) => void
}

export const useSectionStore = create<SectionStore>()(
  devtools((set) => ({
    currentSection:
      window.location.pathname === "/" || window.location.pathname === "/about"
        ? "loader"
        : "works",
    setCurrentSection: (section: string) => set({ currentSection: section }),
  })),
)
